class HeroSlider extends HTMLElement {
  constructor() {
    super();
    this.current_slide = 0;
    this.action_buttons = this.querySelectorAll("button[data-track-action]");
    this.slides = Array.from(this.querySelectorAll("[data-slide]"));
    this.items_to_observe = [this.slides.at(0), this.slides.at(-1)];
    this.interval = null;
  }

  connectedCallback() {
    if (this.slides.length === 1) {
      return;
    }
    this.autoPlay();
    this.action_buttons.forEach((button) => {
      button.addEventListener("click", this.handleClick.bind(this));
    });

    this.items_to_observe.forEach((item, index) => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.action_buttons[index].disabled = true;
            } else {
              this.action_buttons[index].disabled = false;
            }
          });
        },
        {
          root: this,
          threshold: 0.5,
        },
      );

      observer.observe(item);
    });
  }

  autoPlay() {
    const fn = () => {
      this.current_slide < this.slides.length - 1
        ? this.current_slide++
        : (this.current_slide = 0);
      this.slides.forEach((slide, index) => {
        if (index === this.current_slide) {
          slide.setAttribute("data-active", "");
        } else {
          slide.removeAttribute("data-active");
        }
      });
    };
    const t = 6000;
    this.interval = setInterval(fn, t);
  }

  manualMode(index) {
    this.current_slide = index;
    clearInterval(this.interval);
    this.autoPlay();
  }

  handleClick(event) {
    const { trackAction } = event.target.dataset;
    switch (trackAction) {
      case "prev":
        this.current_slide > 0
          ? this.current_slide--
          : (this.current_slide = this.slides.length - 1);
        break;
      case "next":
        this.current_slide < this.slides.length - 1
          ? this.current_slide++
          : (this.current_slide = 0);
        break;
      default:
        this.manualMode(Number(trackAction));
    }
    this.slides.forEach((slide, index) => {
      if (index === this.current_slide) {
        slide.setAttribute("data-active", "");
      } else {
        slide.removeAttribute("data-active");
      }
    });
  }
}

customElements.define("hero-slider", HeroSlider);
